import { render, staticRenderFns } from "./fertigerComponent.vue?vue&type=template&id=67ed5626"
import script from "./fertigerComponent.vue?vue&type=script&lang=js"
export * from "./fertigerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports